module.exports = __webpack_public_path__ + "static/media/23_B.491c869a.png";